define(function() {
	const builder = require('civicsUtils/buildUrlParameters');
	const IPSModelCollection = require('civicsBase/ipsModelCollection');
	const CN = require('civicsUtils/constants');
	const utils = require('civicsUtils/general_utilities');
	const constraint_parser = require('civicsUtils/constraint_parser');
	const AvailableFeatures = require('civicsUtils/available_features');

	return IPSModelCollection.extend({
		urlRoot: '/delegate/civics-api/api/core/views/instruments',
		//urlRoot: '/delegate/civics-api/api/',
		url: function() {
			var parameters = '';
			if (this.urlParameters != undefined) {
				parameters = builder.buildUrlParameters(this.urlParameters)
			}
			if (this.lightweightextensions === true) {
				if (parameters.indexOf('?') >= 0) {
					parameters += '&lightweightextensions=true';
				} else {
					parameters += '?lightweightextensions=true';
				}
			}
			//temporary code while we switch RS parameter names. this way we won't break QA builds.

			if (this.storedProcedureMode === true) {
				if (parameters.indexOf('?') >= 0) {
						this.urlRoot = this.isInMyProjects ? '/delegate/civics-api/api/portal/myinstruments' : '/delegate/civics-api/api/portal/publicinstrumentdetails';
						parameters += '&compatiblemode=true';
				}
			}

			if(AvailableFeatures.ElectronicPlanForCustomers() && this.isInMyProjects)
			{
				if (parameters.indexOf('?') >= 0) {
					parameters += '&indicateeplanenabled=true';
				} else {
					parameters += '?indicateeplanenabled=true';
				}
			}
			//var instrumentService = (this.storedProcedureMode === true) ? "portal/myinstruments" : "core/views/instruments" ;

			//var ret = this.urlRoot + instrumentService + parameters;
			var ret = this.urlRoot + parameters;
			if(ret.indexOf('includecount')>=0){
				if(ret.indexOf('?')<0){
					ret+='?';
				} else {
					ret+='&';
				}
				ret+='gettotalcount=true';
			}
			return ret;
		},
		modelId:function(attrs){
			return attrs.instrumentType+'_'+attrs.id;
		},
		parse: function(response) {
			var data = response.data;
			//if the collection is supposed to manage the has more records flag,
			//we need to check for the extra record, and remove the last one.
			if (this.manageHasMoreRecords === true && this.hasMoreRecordsCheckSize == response.data.length) {
				data.pop();
				this.hasMoreRecords = true;
			} else {
				this.hasMoreRecords = false;
			}


			for (i = 0; i < data.length; i++) {
				switch (data[i].instrumentType.toLowerCase()) {
					case 'buildingapplication':
						data[i]._cdrType = 'building';
						break;
					case 'businesslicense':
						data[i]._cdrType = 'businesslicense';
						break;
					case 'case':
						data[i]._cdrType = 'codeenforcement';
						break;
					case 'planningapplication':
						data[i]._cdrType = 'planning';
						break;
					case 'projectapplication':
						data[i]._cdrType = 'project';
						break;
					case 'tradelicense':
						data[i]._cdrType = 'tradelicense';
						break;
					case 'useapplication':
						data[i]._cdrType = 'use';
						break;
					case 'servicerequest':
						data[i]._cdrType = 'servicerequest';
						// SR status should just be open or close
						data[i].statusDescription = (data[i].status && data[i].status.trim().length > 0) ? i18n.t('CIVICS.COMMON.CLOSED') : i18n.t('CIVICS.COMMON.OPEN');
						break;
					case 'portalscenario':
						data[i].instrumentType = 'portalscenario';
						if (data[i].status && data[i].status.length == 1) {
							switch (data[i].status.toUpperCase()) {
								case 'A':
									data[i].status = 'Active';
									data[i].statusDescription = CN.SCENARIO_STATUS().Active;
									break;
								case 'R':
									data[i].status = 'ReadyToApply';
									data[i].statusDescription = CN.SCENARIO_STATUS().ReadyToApply;
									break;
								case 'P':
									data[i].status = 'ApplicationPending';
									data[i].statusDescription = CN.SCENARIO_STATUS().ApplicationPending;
									break;
								case 'Q':
									data[i].status = 'QuestionsPending';
									data[i].statusDescription = CN.SCENARIO_STATUS().QuestionsPending;
									break;
								default:
									data[i].statusDescription = data[i].status;
									break;
							}
						}
						data[i].portalDescription = data[i].instrumentName;
						break;
					case 'portalinstrument':
						data[i].instrumentType = 'portalinstrument';
						data[i].status = i18n.t('CIVICS.COMMON.OPEN');
						data[i].statusDescription = data[i].status;
						data[i].portalDescription = data[i].instrumentName;
						break;
					default:
						console.log('undefined/invalid product family from the instrument response');
				}
				data[i].computedDescription = Handlebars.helpers['global:computedDescription'](data[i].portalDescription, data[i].description);
				if (data[i].computedDescription.trim().length <= 0) {
					data[i].computedDescription = i18n.t('CIVICS.COMMON.VALUE_NOT_CONFIG');
				}


				if (this.storedProcedureMode) {
					//COMMON
					if (this.isInMyProjects) {
						data[i].constraints = this.parseConstraints(data[i]); //need to get the constraints.
						data[i].logLinks = this.filterLogLinks(data[i]);
					}
					data[i].applicationName = data[i].instrumentName;
					data[i].addedDate = data[i].addedDateTime;
					data[i].currentMilestone = data[i].currentMilestoneCode;
					data[i].applicationNumber = data[i].instrumentNumber;
					data[i].computedDescription = data[i].portalDescription;
					data[i].unpaidFees = data[i].totalUnpaidFees;
					if (data[i].locationLine1 && data[i].locationLine1.trim() != '' && data[i].parcel.id == 1) {
						data[i].locationLine1 = data[i].locationLine1 ? data[i].locationLine1 : '';
						data[i].locationLine2 = data[i].locationLine2 ? data[i].locationLine2 : '';
						data[i].locationLine3 = '';
						data[i].locationLine4 = '';
						data[i].locationLine5 = '';
					} else if (data[i].locationLine3 && data[i].locationLine3.trim() != '') {
						//if the parcel line is populated, make sure the address and X/Y lines are not.
						data[i].locationLine3 = data[i].locationLine3 ? data[i].locationLine3 : '';
						data[i].locationLine1 = '';
						data[i].locationLine2 = '';
						data[i].locationLine4 = '';
						data[i].locationLine5 = '';
					} else {
						//must be X/Y Coordinates. Make sure the second address line is clear.
						data[i].locationLine1 = '';
						data[i].locationLine2 = '';
						data[i].locationLine3 = '';
						data[i].locationLine4 = data[i].Spatial ? 'x: ' + data[i].Spatial.xCoordinate : '';
						data[i].locationLine5 = data[i].Spatial ? 'y: ' + data[i].Spatial.yCoordinate : '';
					}


					//todo: add validation for description something like ... 'value not configured'.
					switch (data[i].instrumentType.toLowerCase()) {
						case 'buildingapplication':
							data[i].processedDate = data[i].processedDateTime;
							data[i].issuedDate = data[i].issuedDateTime;
							data[i].tempCOODate = data[i].tempCooDateTime;
							data[i].COODate = data[i].cooDateTime;
							data[i].finalDate = data[i].finalDateTime;
							data[i].expirationDate = data[i].expireDateTime;
							data[i].workTypeDescription = this.getCodeDefinition(data[i].instrumentSubTypeCode, data[i].instrumentSubTypeCodeDescription);
							break;
						case 'projectapplication':
							data[i].proposedStartDate = data[i].startDate;
							data[i].proposedStateDate = data[i].startDate;
							data[i].proposedStopDate = data[i].endDate;
							data[i].processedDate = data[i].processedDateTime;
							data[i].approvedDate = data[i].approvedDateTime;
							data[i].tempCOODate = data[i].tempCooDateTime;
							data[i].COODate = data[i].cooDateTime;
							data[i].finalDate = data[i].finalDateTime;
							data[i].expirationDate = data[i].expireDateTime;

							data[i].projectPhaseName = data[i].instrumentName;
							data[i].workTypeDescription = this.getCodeDefinition(data[i].instrumentSubTypeCode, data[i].instrumentSubTypeCodeDescription);
							data[i].ProjectSizeDescription = data[i].sizeDescription;
							data[i].PhaseNumber = data[i].phaseNumber;
							data[i].subDivision = data[i].subdivision;
							break;
						case 'planningapplication':
							data[i].approvedDate = data[i].approvedDateTime;
							data[i].issuedDate = data[i].issuedDateTime;
							data[i].tempCOODate = data[i].tempCooDateTime;
							data[i].processedDate = data[i].processedDateTime;
							data[i].COODate = data[i].cooDateTime;
							data[i].finalDate = data[i].finalDateTime;
							data[i].expirationDate = data[i].expireDateTime;
							data[i].workTypeDescription = this.getCodeDefinition(data[i].instrumentSubTypeCode, data[i].instrumentSubTypeCodeDescription);

							data[i].projectPhaseName = data[i].instrumentName;
							break;
						case 'tradelicense':
							data[i].issuedDate = data[i].issuedDateTime;
						  data[i].expirationDate = data[i].expireDateTime;
							data[i].licenseDate = data[i].licenseDateTime;
						  data[i].inactiveDate = data[i].inactiveDateTime;
							data[i].lastRenewalDate = data[i].lastRenewalDateTime;
						  data[i].nextRenewalDate = data[i].nextRenewalDateTime;
							data[i].graceExpireDate = data[i].graceExpireDateTime;

							data[i].licenseCategoryDescription = this.getCodeDefinition(data[i].instrumentSubTypeCode, data[i].instrumentSubTypeCodeDescription);
							break;
						case 'businesslicense':
							data[i].issuedDate = data[i].issuedDateTime;
							data[i].expirationDate = data[i].expireDateTime;
							data[i].licenseDate = data[i].licenseDateTime;
							data[i].inactiveDate = data[i].inactiveDateTime;
							data[i].lastRenewalDate = data[i].lastRenewalDateTime;
							data[i].nextRenewalDate = data[i].nextRenewalDateTime;
							data[i].graceExpireDate = data[i].graceExpireDateTime;

							data[i].licenseCategoryDescription = this.getCodeDefinition(data[i].instrumentSubTypeCode, data[i].instrumentSubTypeCodeDescription);
							data[i].typeOfBusinessDescription = this.getDescriptionFromConstant(data[i].typeOfBusinessName, CN.BUSINESS_TYPES());
							data[i].DBAName = data[i].dbaName;
							data[i].BusinessName = data[i].instrumentName;
							break;
						case 'useapplication':
							data[i].StartDate = data[i].startDate;
							data[i].EndDate = data[i].endDate;
							data[i].processedDate = data[i].processedDateTime;
							data[i].issuedDate = data[i].issuedDateTime;
							data[i].tempCOODate = data[i].tempCooDateTime;
							data[i].COODate = data[i].cooDateTime;
							data[i].finalDate = data[i].finalDateTime;
							data[i].expirationDate = data[i].expireDateTime;
							data[i].workTypeDescription = this.getCodeDefinition(data[i].instrumentSubTypeCode, data[i].instrumentSubTypeCodeDescription);
							break;
						case 'case':
							data[i].processedDate = data[i].processedDateTime;
							data[i].resolutionDate = data[i].resolutionDateTime;
							data[i].expirationDate = data[i].expireDateTime;
							data[i].caseGroupDescription = this.getCodeDefinition(data[i].instrumentSubTypeCode, data[i].instrumentSubTypeCodeDescription);
							data[i].APName = data[i].instrumentName;
							break;
						case 'servicerequest':
							var serviceRequestResolution = data[i].resolution ? data[i].resolution.trim() : '';
							data[i].requestDate = data[i].addedDateTime;
							data[i].status = serviceRequestResolution != '' ? i18n.t('CIVICS.COMMON.CLOSED') : i18n.t('CIVICS.COMMON.OPEN');
							data[i].requestCompleted = serviceRequestResolution != '' ? i18n.t('CIVICS.COMMON.YES') : i18n.t('CIVICS.COMMON.NO');
							data[i].inspectorAssignedDisplay = data[i].inspectorAssigned && data[i].inspectorAssigned.trim() != '' ? i18n.t('CIVICS.COMMON.YES') : i18n.t('CIVICS.COMMON.NO');
							if (data[i].inspectionCompleted) {
								if (utils.dateExists(data[i].inspectionCompleted)) {
									data[i].inspectionCompleted = i18n.t('CIVICS.COMMON.YES');
								} else {
									data[i].inspectionCompleted = i18n.t('CIVICS.COMMON.NO');
								}
							} else {
								data[i].inspectionCompleted = ''
							}
							data[i].resolutionDate = serviceRequestResolution != '' ? data[i].resolutionDateTime : '';
							break;
						default:
							break;
						}

				}

			}



			return data;
		},
		getCodeDefinition: function (code, description){
			var displayValue = '';
			if( code ){
				if( code && code.trim().length > 0 ){
					displayValue = description && description.trim().length > 0 ? description : i18n.t('CIVICS.COMMON.VALUE_NOT_CONFIG');
				}
			}
			return displayValue;
		},
		getDescriptionFromConstant: function (code, types) {
			if (code) {
				for (var i = 0; i < types.length; i++) {
					if (types[i].code === code) {
						return types[i].description;
					}
				}
			}
			return '';
		},
		parseConstraints: function(d) {
			//need to fixed the constraints;
			var constraints;
			if (d.instrumentType.toLowerCase() != "servicerequest") {
				if (d.currentMilestone && d.currentMilestone.code != '' && d.currentMilestone.constraints) {
					constraints = d.currentMilestone.constraints
				}
				return constraint_parser.parseToJSON(constraints, d.instrumentType);
			} else {
				return {};
			}
			//console.log(constraints, constraint_parser.parseToJSON(constraints));
		},
		filterLogLinks: function (d) {
			var loglinks;
			var instType = !d._cdrType ? '' : d._cdrType.toLowerCase();
			var status = !d.status ? '' : d.status;

			if (instType !== "servicerequest") {
				loglinks = d.currentMilestone && d.currentMilestone.logLinks ? d.currentMilestone.logLinks : [];
			} else {
				loglinks = d.logLinks ? d.logLinks : [];
			}

			for (var i = 0; i < loglinks.length; i++) {
				if (status == loglinks[i].statusCode && instType != 'servicerequest') {
					loglinks.splice(i, 1);
					i--;
				}
				else if (loglinks[i].isInMyProjects == false) {
					loglinks.splice(i, 1);
					i--;
				}
			}
			return loglinks;
		}
	});
});
